import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import pl from './locales/pl.json';

export const defaultLanguage = 'pl';

export const supportedLanguages = ['pl', 'en'] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

const isSupported = (value: string | null): value is SupportedLanguage =>
  !!value && (supportedLanguages as readonly string[]).includes(value);

const languageFromUrl = (): SupportedLanguage => {
  if (typeof window === 'undefined') {
    return defaultLanguage;
  }

  const value = new URLSearchParams(window.location.search).get('lng');

  return isSupported(value) ? value : defaultLanguage;
};

i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
    en: { translation: en },
  },
  lng: languageFromUrl(),
  fallbackLng: defaultLanguage,
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
  returnObjects: true,
});

export default i18n;
